import {
  SET_CUSTOM_THEME,
  UPDATE_CUSTOM_THEME
} from 'constants/ActionTypes'
import { createAction } from 'redux-actions'

export const setCustomTheme = createAction(SET_CUSTOM_THEME, payload => payload)

export const updateCustomTheme = createAction(UPDATE_CUSTOM_THEME, payload => payload)
